import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw53Handlers = [
  // カテゴリ情報取得 /kymw53/getCategoryInfo
  http.post(
    PlessService.SERVICE.getCategoryInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCategoryInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // カテゴリ情報削除 /kymw53/deleteCategoryInfo
  http.post(
    PlessService.SERVICE.deleteCategoryInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(deleteCategoryInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // カテゴリ情報登録 /kymw53/registCategoryInfo
  http.post(
    PlessService.SERVICE.registCategoryInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(registCategoryInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // カテゴリ情報更新 /kymw53/updateCategoryInfo
  http.post(
    PlessService.SERVICE.updateCategoryInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(updateCategoryInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // カテゴリ表示順情報更新 /kymw53/updateCategoryShowSeqInfo
  http.post(
    PlessService.SERVICE.updateCategoryShowSeqInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(updateCategoryShowSeqInfoInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
];

const getCategoryInfoResponse = {
  "status": 'ok',
  "message": '処理完了',
  "result": {
    "obj": {
      "OrderCode": "2023220",
      "Category": [
        {
          "OrderCode": "2023220",
          "CategoryCode": "002000000",
          "CategoryName": "やさい・くだもの",
          "ParentCategoryCode": "",
          "CategoryLevel": 1,
          "ShowSeq": 1,
          "BorderLineDiv": "0",
          "ShowDiv": "1",
          "SellAreaDiv": "00010111",
          "UpdateDate": "2012/07/10 22:28:38",
          "StockLimitFlg": "0",
          "TimeSaleFlg": "1",
          "CategoryDiv": "0",
          "Category": [
            {
              "OrderCode": "2023220",
              "CategoryCode": "002001000",
              "CategoryName": "きゅうり・トマトなど",
              "ParentCategoryCode": "002000000",
              "CategoryLevel": 2,
              "ShowSeq": 1,
              "BorderLineDiv": "0",
              "ShowDiv": "1",
              "SellAreaDiv": "00010111",
              "UpdateDate": "2012/07/10 22:28:38",
              "StockLimitFlg": "0",
              "TimeSaleFlg": "0",
              "CategoryDiv": "0",
              "Category": [
              ]
            },
            {
              "OrderCode": "2023220",
              "CategoryCode": "002002000",
              "CategoryName": "葉もの・ねぎ類など",
              "ParentCategoryCode": "002000000",
              "CategoryLevel": 2,
              "ShowSeq": 2,
              "BorderLineDiv": "0",
              "ShowDiv": "1",
              "SellAreaDiv": "00010111",
              "UpdateDate": "2012/07/10 22:28:38",
              "StockLimitFlg": "0",
              "TimeSaleFlg": "1",
              "CategoryDiv": "0",
              "Category": [
              ]
            },
          ]
        },
        {
          "OrderCode": "2023220",
          "CategoryCode": "003000000",
          "CategoryName": "お魚",
          "ParentCategoryCode": "",
          "CategoryLevel": 1,
          "ShowSeq": 2,
          "BorderLineDiv": "0",
          "ShowDiv": "0",
          "SellAreaDiv": "00010111",
          "UpdateDate": "2014/11/19 10:06:51",
          "StockLimitFlg": "0",
          "TimeSaleFlg": "0",
          "CategoryDiv": "1",
          "Category": [
            {
              "OrderCode": "2023220",
              "CategoryCode": "003001000",
              "CategoryName": "お刺身・鮮魚",
              "ParentCategoryCode": "003000000",
              "CategoryLevel": 2,
              "ShowSeq": 1,
              "BorderLineDiv": "0",
              "ShowDiv": "0",
              "SellAreaDiv": "00010111",
              "UpdateDate": "2012/07/10 22:28:38",
              "StockLimitFlg": "0",
              "TimeSaleFlg": "0",
              "CategoryDiv": "1",
              "Category": [
              ]
            },
            {
              "OrderCode": "2023220",
              "CategoryCode": "003002000",
              "CategoryName": "切り身・下処理済魚",
              "ParentCategoryCode": "003000000",
              "CategoryLevel": 2,
              "ShowSeq": 2,
              "BorderLineDiv": "0",
              "ShowDiv": "0",
              "SellAreaDiv": "00010111",
              "UpdateDate": "2012/07/10 22:28:38",
              "StockLimitFlg": "0",
              "TimeSaleFlg": "0",
              "CategoryDiv": "1",
              "Category": [
              ]
            },
          ]
        },
        {
          "OrderCode": "2023220",
          "CategoryCode": "003000000",
          "CategoryName": "お魚",
          "ParentCategoryCode": "",
          "CategoryLevel": 1,
          "ShowSeq": 2,
          "BorderLineDiv": "0",
          "ShowDiv": "0",
          "SellAreaDiv": "00010111",
          "UpdateDate": "2014/11/19 10:06:51",
          "StockLimitFlg": "1",
          "TimeSaleFlg": "0",
          "CategoryDiv": "1",
          "Category": [
            {
              "OrderCode": "2023220",
              "CategoryCode": "003001000",
              "CategoryName": "お刺身・鮮魚",
              "ParentCategoryCode": "003000000",
              "CategoryLevel": 2,
              "ShowSeq": 1,
              "BorderLineDiv": "0",
              "ShowDiv": "0",
              "SellAreaDiv": "00010111",
              "UpdateDate": "2012/07/10 22:28:38",
              "StockLimitFlg": "1",
              "TimeSaleFlg": "0",
              "CategoryDiv": "1",
              "Category": [
              ]
            },
            {
              "OrderCode": "2023220",
              "CategoryCode": "003002000",
              "CategoryName": "切り身・下処理済魚",
              "ParentCategoryCode": "003000000",
              "CategoryLevel": 2,
              "ShowSeq": 2,
              "BorderLineDiv": "0",
              "ShowDiv": "0",
              "SellAreaDiv": "00010111",
              "UpdateDate": "2012/07/10 22:28:38",
              "StockLimitFlg": "1",
              "TimeSaleFlg": "0",
              "CategoryDiv": "1",
              "Category": [
              ]
            },
          ]
        }
      ]
    }
  }
}

const deleteCategoryInfoResponse = {
  "status": "ok",
  "message": "処理終了",
}

const registCategoryInfoResponse = {
  "status": "ok",
  "message": "処理終了",
}

const updateCategoryInfoResponse = {
  "status": "ok",
  "message": "処理終了",
}

const updateCategoryShowSeqInfoInfoResponse = {
  "status": "ok",
  "message": "処理終了",
}
